import React from 'react';

import { createStyles, Stack } from '@mantine/core';
import { useAuth } from 'context/auth-context';
import { AthleteRetrieve } from 'types';

import ActivePackagesContent from './components/ActivePackagesContent';
import AthleteNotesContent from './components/AthleteNotesContent';
import ConnectedProfilesCard from './components/ConnectedProfilesCard';
import GeneralContent from './components/GeneralContent';
import GLMLinkCard from './components/GLMLinkCard';
import PaymentMethodsContent from './components/PaymentMethodsContent';
import StatusHistoryCard from './components/StatusHistoryCard';

const useStyles = createStyles(theme => ({
  container: {
    padding: theme.spacing.xl,
    display: 'grid',
    gridTemplateColumns: '2fr 4fr',
    gap: theme.spacing.lg,
    [theme.fn.smallerThan('lg')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
}));

interface IGeneralInfoProps {
  athlete: AthleteRetrieve;
  permission?: boolean;
}

const GeneralInfo = ({ athlete, permission = true }: IGeneralInfoProps): JSX.Element => {
  const { classes } = useStyles();
  const { session } = useAuth();
  return (
    <div className={classes.container}>
      <Stack>
        <GeneralContent athlete={athlete} permission={permission} />
        {!!athlete.connectedType && <ConnectedProfilesCard athlete={athlete} permission={permission} />}
        {session?.gym?.ghlV2Enabled && <GLMLinkCard athleteId={athlete.athleteId} />}
      </Stack>
      <Stack>
        <PaymentMethodsContent athlete={athlete} permission={permission} />
        <ActivePackagesContent athlete={athlete} />
        <StatusHistoryCard athlete={athlete} permission={permission} />
        <AthleteNotesContent athlete={athlete} permission={permission} />
      </Stack>
    </div>
  );
};

export default GeneralInfo;
